var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.0781 8.57812C17.0781 5.77355 14.8046 3.5 12 3.5C9.19544 3.50001 6.92189 5.77356 6.92188 8.57812C6.92187 11.3827 9.19543 13.6562 12 13.6562C14.8046 13.6562 17.0781 11.3827 17.0781 8.57812ZM18.5781 8.57812C18.5781 12.2111 15.633 15.1562 12 15.1562C8.367 15.1562 5.42187 12.2111 5.42188 8.57812C5.42189 4.94513 8.36701 2.00001 12 2C15.633 2 18.5781 4.94512 18.5781 8.57812Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18H15L15.0771 18.0039C15.4551 18.0425 15.75 18.3618 15.75 18.75C15.75 19.1381 15.4551 19.4575 15.0771 19.4961L15 19.5H12.75V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V19.5H9C8.5858 19.5 8.25003 19.1642 8.25 18.75C8.25 18.3358 8.58579 18 9 18H11.25V15.1113C11.4962 15.1393 11.7463 15.1562 12 15.1562C12.2537 15.1563 12.5038 15.1393 12.75 15.1113V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoFemale);
export default __webpack_public_path__ + "static/media/DuoFemale.e470fe259b263cd59b119dd9ef2b3c6e.svg";
export { ForwardRef as ReactComponent };